import { render } from "./UiIconButton.vue?vue&type=template&id=9743d740"
import script from "./UiIconButton.vue?vue&type=script&lang=js"
export * from "./UiIconButton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__